import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useToast,
  Box,
  Text,
  Divider,
} from "@chakra-ui/react";
import { sendReportRequestEmail } from "../../../utils/firebase";
import { FormContainer, FormData } from "./FormContainer";

interface IReportRequestModal {
  mentorName: string;
  mentorId: string;
  isOpen: boolean;
  onClose: () => void;
  workshopTitle?: string;
  workshopId?: string;
}

export const ReportRequestModal: React.FC<IReportRequestModal> = ({
  isOpen,
  onClose,
  workshopTitle,
  workshopId,
  mentorName,
  mentorId,
}) => {
  const toast = useToast();
  const initialRef = React.useRef<HTMLInputElement | null>(null);

  const onSendReportRequestEmail = async (formValues: FormData) => {
    try {
      const requestData = {
        message: formValues.text,
        email: formValues.email,
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        company: formValues.company,
        mentorName: mentorName,
        mentorId: mentorId,
        workshopTitle: workshopTitle ?? "",
        workshopId: workshopId ?? "",
      };
      await sendReportRequestEmail(requestData);
      toast({
        title: "Die Anfrage wurde erfolgreich versendet",
        description:
          "Vielen Dank für deine Meldung. Wir gehen deiner Anfrage nach und melden uns bei weiteren Rückfragen bei dir.",
        status: "success",
        onCloseComplete: () => onClose(),
        isClosable: true,
        duration: 2000,
        position: "top",
      });
    } catch (error) {
      console.log(`Sending report request failed with error: ${error}`);
      toast({
        title:
          "Die Anfrage konnte nicht gesendet werden. Bitte versuche es später nochmal",
        status: "error",
        isClosable: true,
        position: "top",
      });
    }
  };

  return (
    <Modal
      initialFocusRef={initialRef}
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
    >
      <ModalOverlay />
      <ModalContent p={4}>
        <ModalHeader>Mentor oder Angebot melden</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Box
            mb={8}
            p={4}
            borderRadius={8}
            background={"primaryColor"}
            color={"white"}
          >
            <Text mb={2}>
              Du findest, dass Inhalte in einem Mentorenprofil oder einem
              Angebot unrichtig oder anstößig sind, oder gegen unsere
              Allgemeinen Geschäftsbedingungen verstoßen?
            </Text>
            <Text>
              Wir werden deine Meldung sorgfältig prüfen und mit dem Mentor bzw.
              der Mentorin in Kontakt treten, um das Problem zu lösen. Vielen
              Dank für deinen Hinweis!
            </Text>
          </Box>
          <Divider my={8} />
          <Box mb={8}>
            <Text mb={6} fontSize={"lg"} fontWeight={"bold"}>
              Welchen Inhalt möchtest du melden?
            </Text>

            {workshopTitle && (
              <Box mb={4}>
                <Text fontWeight={"bold"}>Angebot</Text>
                <Text>{workshopTitle}</Text>
              </Box>
            )}
            {mentorName && (
              <Box>
                <Text fontWeight={"bold"}>Mentor</Text>
                <Text>{mentorName}</Text>
              </Box>
            )}
          </Box>
          <Divider my={8} />
          <FormContainer onSendReportRequest={onSendReportRequestEmail} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
